export default {
  english: {
    label: 'i24NEWS+',
    link: '/en/i24news-plus',
  },
  french: {
    label: 'i24NEWS+',
    link: '/fr/i24news-plus',
  },
  arabic: {
    label: 'i24NEWS+',
    link: '/ar/بلس-i24news',
  },
  hebrew: {
    label: '',
    link: '',
  },
  persian: {
    label: '',
    link: '',
  },
}
